import React from "react"
import styled, { css } from 'styled-components'

import { Title, Item } from '../../../shared/Section'
import GuestList from './GuestList'
// import { Date, Week } from '../../../shared/Date'

import Guest1 from '../../../../images/thumb/profile1.png'
import Guest2 from '../../../../images/thumb/profile2.png'
import Guest3 from '../../../../images/thumb/profile3.png'

const guests = [
  { name: "林 響太朗", job: "映像作家・写真家", thumb: Guest1 },
  { name: "梶原 恵", job: "デザイナー", thumb: Guest2 },
  { name: "清水 淳子", job: "Design researcher / Visual facilitator", thumb: Guest3},
]

const Wrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
`

const TextArea = styled.div`
  flex: 2 1 40%;
  padding: 0 0 4.0rem 0;
  ${({ theme: { breakpoints }}) => css`
    @media (min-width: ${breakpoints.md}px) {
      padding: 0 9.6rem 4.0rem 0;
    }
  `}
`

const InnerHeader = styled.h3`
  padding-top: 2.4rem;
  font-size: 1.4rem;
  ${({ theme: { breakpoints }}) => css`
    @media (min-width: ${breakpoints.md}px) {
      // padding-top: 1.2rem;
      // font-size: 3.2rem;
    }
  `}
`

const Description = styled.p`
`

const DateWrapper = styled.div`
  padding: 2.4rem 0;
`

const GuestArea = styled.div`
  flex: 0 1 auto;
`

const Note = styled.div`
  padding: 2.4rem 0 ;
  font-weight: 700;
  line-height: 1.9rem;
`

const Youtube = styled.div`
  position: relative;
  width: 100%;
  margin-top: 4.0rem;
  padding-top: 56.25%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  iframe {
    position: absolute;
    top: 0;
    right: 0;
    width: 100% !important;
    height: 100% !important;
  }
`

const Event = () => {

  const now = new Date()
  const period = new Date(2021, 2, 20, 12, 0, 0)

  return (
    <>
      {/* <Content title={"Talk Show"} sub={"「私の分岐点」"}> */}
      <Title sub={'「私の分岐点」'}>Talk Show</Title>
      {/* <InnerHeader>YouTube Live にて配信予定</InnerHeader> */}
      <Item>
        <Wrapper>
          <TextArea>
            <Description>本学科の卒業生である映像作家の林響太朗さんとデザイナーの梶原恵さんをお迎えし、お二人の今までとそこから広がる未来についてのトークを繰り広げていただきます。</Description>
            {/* <DateWrapper>
              <Date>3.7<Week>Sun</Week> 13:00 - 15:00</Date>
            </DateWrapper> */}
            <Note>
              {/* <p>※ 当日は20名様限定の観覧席をご用意します。（入場券とは別でご予約が必要です。）</p>
              <p>※ Youtube Liveでの無料配信を予定しています。</p> */}
              <p>{now < period ? `※ 期間限定公開中（3/20 11:59 まで）` : `※ 終了しました`}</p>
            </Note>
          </TextArea>
          <GuestArea>
            <GuestList guests={guests}/>
          </GuestArea>
        </Wrapper>
        {now < period ? (
          <Youtube>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/znvM8IBGMfA" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          </Youtube>
        ) : null}
      </Item>
      {/* </Content> */}
    </>
  )
}

export default Event